import devConfig from './config.dev';
import testConfig from './config.test';
import uatConfig from './config.uat';
import prodConfig from './config.prod';
import globalConfig from './config.global';
const ENV = {
  DEV: 'DEV',
  TEST: 'TEST',
  UAT: 'UAT',
  PROD: 'PROD',
  GLOBAL: 'GLOBAL'
};
const envMapConfig = {
  [ENV.DEV]: devConfig,
  [ENV.TEST]: testConfig,
  [ENV.UAT]: uatConfig,
  [ENV.PROD]: prodConfig,
  [ENV.GLOBAL]: globalConfig
};
export const REACT_APP_ENV = process.env.REACT_APP_ENV || ENV.DEV;
const getConfig = () => {
  return envMapConfig[REACT_APP_ENV];
};

export default getConfig();
